import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { HighlightDirective } from './directives/highlight.directive';
import { SecurePipe } from './pipes/SecureHttp.pipe';
import { LocalstorageService } from './localstorage.service';
import { GlobalsServiceConfig } from './globals.config';
import { GlobalsService } from './globals.service';
import { HelperService } from './helper.service';
import { NotifyService } from './notify.service';
import { ConfirmDialog } from './dialogs/confirm/confirm.component';
import { CustomMaterialModule } from './material.module';
import { KeysPipe } from './pipes/Enum.pipe';

@NgModule({
  imports: [
    CommonModule, 
    FormsModule,
    CustomMaterialModule    
  ],
  declarations: [HighlightDirective, SecurePipe, KeysPipe, ConfirmDialog],
  exports: [HighlightDirective, SecurePipe, KeysPipe, ConfirmDialog, CustomMaterialModule],
  entryComponents: [ConfirmDialog]
})
export class SharedModule 
{
  static forRoot(): ModuleWithProviders
  {
    return {
      ngModule: SharedModule,
      providers: [LocalstorageService, GlobalsServiceConfig, GlobalsService, HelperService, NotifyService]
    };
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts